/**
 * ar: 阿拉伯语
 * br: 葡萄牙语
 * cn: 简体中文
 * de: 德语
 * en: 英语
 * es: 西语
 * fr: 法语
 * id: 印尼语
 * inn: 印度语
 * it: 意大利语
 * jp: 日语
 * kr: 韩语
 * nl: 荷兰语
 * ru: 俄语
 * tr: 土耳其语
 * tw: 繁体中文
 */

//各语种 SEO站点 首页 链接
const HitPaw_Home_LinkData = {
  ar: 'https://ar.hitpaw.com/',
  br: 'https://www.hitpaw.com.br/',
  cn: '',
  de: 'https://www.hitpaw.de/',
  en: 'https://www.hitpaw.com/',
  es: 'https://www.hitpaw.es/',
  fr: 'https://www.hitpaw.fr/',
  id: 'https://www.hitpaw.id/',
  inn: 'https://www.hitpaw.in/',
  it: 'https://www.hitpaw.it/',
  jp: 'https://www.hitpaw.jp/',
  kr: 'https://www.hitpaw.kr/',
  nl: 'https://www.hitpaw.nl/',
  ru: 'https://www.hitpaw.ru/',
  tr: 'https://tr.hitpaw.com/',
  tw: 'https://www.hitpaw.tw/',
};

//各语种 SEO站点 去水印产品页 链接
const HitPaw_WatermarkRemover_Product_LinkData = {
  ar: 'https://ar.hitpaw.com/remove-watermark.html',
  br: 'https://www.hitpaw.com.br/remove-watermark.html',
  cn: '',
  de: 'https://www.hitpaw.de/remove-watermark.html',
  en: 'https://www.hitpaw.com/remove-watermark.html',
  es: 'https://www.hitpaw.es/remove-watermark.html',
  fr: 'https://www.hitpaw.fr/remove-watermark.html',
  id: 'https://www.hitpaw.id/remove-watermark.html',
  inn: 'https://www.hitpaw.in/remove-watermark.html',
  it: 'https://www.hitpaw.it/remove-watermark.html',
  jp: 'https://www.hitpaw.jp/remove-watermark.html',
  kr: 'https://www.hitpaw.kr/remove-watermark.html',
  nl: 'https://www.hitpaw.nl/remove-watermark.html',
  ru: 'https://www.hitpaw.ru/remove-watermark.html',
  tr: 'https://tr.hitpaw.com/remove-watermark.html',
  tw: 'https://www.hitpaw.tw/remove-watermark.html',
};

//各语种 SEO站点 落地页 链接
const HitPaw_OnlineTools_LinkData = {
  ar: 'https://ar.hitpaw.com/online-tools.html',
  br: 'https://online.hitpaw.com.br/',
  cn: '',
  de: 'https://online.hitpaw.de/',
  en: 'https://online.hitpaw.com/',
  es: 'https://online.hitpaw.es/',
  fr: 'https://online.hitpaw.fr/',
  id: 'https://online.hitpaw.id/',
  inn: 'https://online.hitpaw.in/',
  it: 'https://online.hitpaw.it/',
  jp: 'https://online.hitpaw.jp/',
  kr: 'https://online.hitpaw.kr/',
  nl: 'https://online.hitpaw.nl/',
  ru: 'https://online.hitpaw.ru/',
  tr: 'https://tr.hitpaw.com/online-tools.html',
  tw: 'https://online.hitpaw.tw/',
};

//各语种 SEO站点 HitPaw Toolkit 购买页面 链接
const HitPawToolkit_Buy_LinkData = {
  ar: {
    win: 'https://ar.hitpaw.com/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://ar.hitpaw.com/purchase/buy-hitpaw-toolkit-mac.html',
  },
  br: {
    win: 'https://www.hitpaw.com.br/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.com.br/purchase/buy-hitpaw-toolkit-mac.html',
  },
  cn: {
    win: '',
    mac: '',
  },
  de: {
    win: 'https://www.hitpaw.de/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.de/purchase/buy-hitpaw-toolkit-mac.html',
  },
  en: {
    win: 'https://www.hitpaw.com/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.com/purchase/buy-hitpaw-toolkit-mac.html',
  },
  es: {
    win: 'https://www.hitpaw.es/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.es/purchase/buy-hitpaw-toolkit-mac.html',
  },
  fr: {
    win: 'https://www.hitpaw.fr/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.fr/purchase/buy-hitpaw-toolkit-mac.html',
  },
  id: {
    win: 'https://www.hitpaw.id/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.id/purchase/buy-hitpaw-toolkit-mac.html',
  },
  inn: {
    win: 'https://www.hitpaw.in/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.in/purchase/buy-hitpaw-toolkit-mac.html',
  },
  it: {
    win: 'https://www.hitpaw.it/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.it/purchase/buy-hitpaw-toolkit-mac.html',
  },
  jp: {
    win: 'https://www.hitpaw.jp/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.jp/purchase/buy-hitpaw-toolkit-mac.html',
  },
  kr: {
    win: 'https://www.hitpaw.kr/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.kr/purchase/buy-hitpaw-toolkit-mac.html',
  },
  nl: {
    win: 'https://www.hitpaw.nl/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.nl/purchase/buy-hitpaw-toolkit-mac.html',
  },
  ru: {
    win: 'https://www.hitpaw.ru/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://www.hitpaw.ru/purchase/buy-hitpaw-toolkit-mac.html',
  },
  tr: {
    win: 'https://tr.hitpaw.com/purchase/buy-hitpaw-toolkit.html',
    mac: 'https://tr.hitpaw.com/purchase/buy-hitpaw-toolkit-mac.html',
  },
  tw: {
    win: '',
    mac: '',
  },
};

//各语种 SEO站点 HitPaw Watermark Remover 购买页面 链接
const HitPawWatermarkRemover_Buy_LinkData = {
  ar: {
    win: 'https://ar.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://ar.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  br: {
    win: 'https://www.hitpaw.com.br/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.com.br/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  cn: {
    win: '',
    mac: '',
  },
  de: {
    win: 'https://www.hitpaw.de/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.de/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  en: {
    win: 'https://www.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  es: {
    win: 'https://www.hitpaw.es/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.es/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  fr: {
    win: 'https://www.hitpaw.fr/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.fr/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  id: {
    win: 'https://www.hitpaw.id/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.id/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  inn: {
    win: 'https://www.hitpaw.in/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.in/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  it: {
    win: 'https://www.hitpaw.it/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.it/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  jp: {
    win: 'https://www.hitpaw.jp/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.jp/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  kr: {
    win: 'https://www.hitpaw.kr/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.kr/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  nl: {
    win: 'https://www.hitpaw.nl/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.nl/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  ru: {
    win: 'https://www.hitpaw.ru/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.ru/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  tr: {
    win: 'https://tr.hitpaw.com/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://tr.hitpaw.com/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
  tw: {
    win: 'https://www.hitpaw.tw/purchase/buy-hitpaw-remove-watermark.html',
    mac: 'https://www.hitpaw.tw/purchase/buy-hitpaw-remove-watermark-mac.html',
  },
};

//各语种 HitPaw Toolkit 安装包 链接
const HitPawToolkit_EXE_LinkData = {
  ar: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2853.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3253.dmg',
  },
  br: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2852.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3252.dmg',
  },
  cn: {
    win: '',
    mac: '',
  },
  de: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2847.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3247.dmg',
  },
  en: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2702.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3244.dmg',
  },
  es: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2848.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3248.dmg',
  },
  fr: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2849.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3249.dmg',
  },
  id: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2921.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3245.dmg',
  },
  inn: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_3101.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3367.dmg',
  },
  it: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2854.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3366.dmg',
  },
  jp: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2850.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3250.dmg',
  },
  kr: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2943.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3352.dmg',
  },
  nl: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_3320.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3505.dmg',
  },
  ru: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2851.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3251.dmg',
  },
  tr: {
    win: 'https://download.hitpaw.com/go/hitpaw-toolkit_2947.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-toolkit-mac_3246.dmg',
  },
  tw: {
    win: '',
    mac: '',
  },
};

const HitPaw_Video_Converter = {
  ar: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4305.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4307.dmg',
  },
  br: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4312.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4313.dmg',
  },
  cn: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4419.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4420.dmg',
  },
  de: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4380.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4381.dmg',
  },
  en: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4283.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4284.dmg',
  },
  es: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4351.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4350.dmg',
  },
  fr: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4328.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4329.dmg',
  },
  id: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4432.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4434.dmg',
  },
  inn: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4409.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4410.dmg',
  },
  it: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4395.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4397.dmg',
  },
  jp: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4352.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4340.dmg',
  },
  kr: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4294.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4295.dmg',
  },
  nl: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_5388.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_5389.dmg',
  },
  ru: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4371.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4372.dmg',
  },
  tr: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4357.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4358.dmg',
  },
  tw: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-converter-ol_4369.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-converter-mac-ol_4370.dmg',
  },
};

//Convert Seo 页面
const HitPawConvertLinkData = {
  ar: 'https://ar.hitpaw.com/video-converter.html',
  br: 'https://www.hitpaw.com.br/video-converter.html?online',
  cn: 'https://www.hitpaw.com/video-converter.html',
  de: 'https://www.hitpaw.de/video-converter.html?online',
  en: 'https://www.hitpaw.com/video-converter.html',
  es: 'https://www.hitpaw.es/video-converter.html',
  fr: 'https://www.hitpaw.fr/video-converter.html?online',
  id: 'https://www.hitpaw.id/video-converter.html?online',
  inn: 'https://www.hitpaw.in/video-converter.html?online',
  it: 'https://www.hitpaw.it/video-converter.html?online',
  jp: 'https://www.hitpaw.jp/video-converter.html?online',
  kr: 'https://www.hitpaw.kr/video-converter.html?online',
  nl: 'https://www.hitpaw.nl/video-converter.html?online',
  ru: 'https://www.hitpaw.ru/video-converter.html?online',
  tr: 'https://tr.hitpaw.com/video-converter.html',
  tw: 'https://www.hitpaw.tw/video-converter.html?online',
};

//各语种 HitPaw Watermark Remover 安装包 链接
const HitPawWatermarkRemover_EXE_LinkData = {
  ar: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_3563.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_3564.dmg',
  },
  br: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_2767.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_2768.dmg',
  },
  cn: {
    win: '',
    mac: '',
  },
  de: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_2772.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_2773.dmg',
  },
  en: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_2739.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_2740.dmg',
  },
  es: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_2758.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_2760.dmg',
  },
  fr: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_2759.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_2761.dmg',
  },
  id: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_2948.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_2949.dmg',
  },
  inn: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_3102.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_3103.dmg',
  },
  it: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_2800.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_2801.dmg',
  },
  jp: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_2770.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_2769.dmg',
  },
  kr: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_2766.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_2765.dmg',
  },
  nl: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_3330.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_3329.dmg',
  },
  ru: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_2763.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_2764.dmg',
  },
  tr: {
    win: 'https://download.hitpaw.com/go/hitpaw-watermark-remover_3301.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-watermark-remover-mac_3302.dmg',
  },
  tw: {
    win: '',
    mac: '',
  },
};

//各语种 HitPaw Video Editor 安装包 链接
const HitPawVideoEditor_EXE_LinkData = {
  ar: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4320.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4321.dmg',
  },
  br: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4317.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4318.dmg',
  },
  cn: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4423.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4424.dmg',
  },
  de: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4377.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4379.dmg',
  },
  en: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4287.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4288.dmg',
  },
  es: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4436.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4437.dmg',
  },
  fr: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4333.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4334.dmg',
  },
  id: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4427.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4428.dmg',
  },
  inn: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4413.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4414.dmg',
  },
  it: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4403.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4404.dmg',
  },
  jp: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4346.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4347.dmg',
  },
  kr: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4298.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4299.dmg',
  },
  nl: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4341.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4344.dmg',
  },
  ru: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4398.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4401.dmg',
  },
  tr: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4361.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4362.dmg',
  },
  tw: {
    win: 'https://download.hitpaw.com/go/hitpaw-video-editor-ol_4382.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-video-editor-mac-ol_4386.dmg',
  },
};

//各语种 HitPaw Video Editor 购买 链接
const HitPawVideoEditor_Buy_LinkData = {
  ar: {
    win: 'https://ar.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  br: {
    win: 'https://www.hitpaw.com.br/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  cn: {
    win: '',
    mac: '',
  },
  de: {
    win: 'https://www.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  en: {
    win: 'https://www.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  es: {
    win: 'https://www.hitpaw.es/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  fr: {
    win: 'https://www.hitpaw.fr/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  id: {
    win: 'https://www.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  inn: {
    win: 'https://www.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  it: {
    win: 'https://www.hitpaw.it/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  jp: {
    win: 'https://www.hitpaw.jp/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  kr: {
    win: 'https://www.hitpaw.kr/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  nl: {
    win: 'https://www.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  ru: {
    win: 'https://www.hitpaw.ru/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  tr: {
    win: 'https://www.hitpaw.com/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
  tw: {
    win: 'https://www.hitpaw.tw/purchase/buy-hitpaw-video-editor.html',
    mac: '',
  },
};
const Hitpaw_Cutter_LinkData = {
  ar: 'https://online.hitpaw.com/cut-video-online.html',
  br: 'https://online.hitpaw.com.br/cut-video-online.html',
  cn: 'https://online.hitpaw.com/cut-video-online.html',
  de: 'https://online.hitpaw.com/cut-video-online.html',
  en: 'https://online.hitpaw.com/cut-video-online.html',
  es: 'https://online.hitpaw.es/cut-video-online.html',
  fr: 'https://online.hitpaw.com/cut-video-online.html',
  id: 'https://online.hitpaw.com/cut-video-online.html',
  inn: 'https://online.hitpaw.com/cut-video-online.html',
  it: 'https://online.hitpaw.com/cut-video-online.html',
  jp: 'https://online.hitpaw.com/cut-video-online.html',
  kr: 'https://online.hitpaw.kr/cut-video-online.html',
  nl: 'https://online.hitpaw.com/cut-video-online.html',
  ru: 'https://online.hitpaw.com/cut-video-online.html',
  tr: 'https://online.hitpaw.com/cut-video-online.html',
  tw: 'https://online.hitpaw.com/cut-video-online.html',
};

const HitPaw_Screen_Recorder_LinkData = {
  ar: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4302.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3789.dmg',
  },
  br: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4304.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3788.dmg',
  },
  cn: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4417.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3830.dmg',
  },
  de: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4373.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3823.dmg',
  },
  en: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4281.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3781.dmg',
  },
  es: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4402.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3834.dmg',
  },
  fr: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4325.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3833.dmg',
  },
  id: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4430.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3827.dmg',
  },
  inn: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4407.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3828.dmg',
  },
  it: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4391.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3790.dmg',
  },
  jp: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4310.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3808.dmg',
  },
  kr: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4292.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3787.dmg',
  },
  nl: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4309.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3826.dmg',
  },
  ru: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4367.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3824.dmg',
  },
  tr: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4355.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3825.dmg',
  },
  tw: {
    win: 'https://download.hitpaw.com/go/screen-recorder-ol_4365.exe',
    mac: 'https://download.hitpaw.com/go/hitpaw-screen-recorder-mac_3832.dmg',
  },
};

//各语种 HitPaw Video Editor 产品页 链接
const HitPawVideoEdito_Product_LinkData = {
  ar: 'https://ar.hitpaw.com/video-editor.html',
  br: 'https://www.hitpaw.com.br/video-editor.html',
  cn: '',
  de: 'https://www.hitpaw.com/video-editor.html',
  en: 'https://www.hitpaw.com/video-editor.html',
  es: 'https://www.hitpaw.es/video-editor.html',
  fr: 'https://www.hitpaw.fr/video-editor.html',
  id: 'https://www.hitpaw.id/video-editor.html',
  inn: 'https://www.hitpaw.com/video-editor.html',
  it: 'https://www.hitpaw.it/video-editor.html',
  jp: 'https://www.hitpaw.jp/video-editor.html',
  kr: 'https://www.hitpaw.kr/video-editor.html',
  nl: 'https://www.hitpaw.com/video-editor.html',
  ru: 'https://www.hitpaw.com/video-editor.html',
  tr: 'https://www.hitpaw.com/video-editor.html',
  tw: 'https://www.hitpaw.tw/video-editor.html',
};

const HitPaw_Service_LinkData = {
  ar: 'https://ar.hitpaw.com/tools/v2/account.html#/services-policy',
  br: 'https://online.hitpaw.com.br/tools/v2/account.html#/services-policy',
  de: 'https://online.hitpaw.de/tools/v2/account.html#/services-policy',
  en: 'https://online.hitpaw.com/tools/v2/account.html#/services-policy',
  es: 'https://online.hitpaw.es/tools/v2/account.html#/services-policy',
  fr: 'https://online.hitpaw.fr/tools/v2/account.html#/services-policy',
  id: 'https://online.hitpaw.id/tools/v2/account.html#/services-policy',
  inn: 'https://online.hitpaw.in/tools/v2/account.html#/services-policy',
  it: 'https://online.hitpaw.it/tools/v2/account.html#/services-policy',
  jp: 'https://online.hitpaw.jp/tools/v2/account.html#/services-policy',
  kr: 'https://online.hitpaw.kr/tools/v2/account.html#/services-policy',
  nl: 'https://online.hitpaw.nl/tools/v2/account.html#/services-policy',
  ru: 'https://online.hitpaw.ru/tools/v2/account.html#/services-policy',
  tr: 'https://tr.hitpaw.com/tools/v2/account.html#/services-policy',
  tw: 'https://online.hitpaw.tw/tools/v2/account.html#/services-policy',
};

const HitPaw_Privacy_LinkData = {
  ar: 'https://ar.hitpaw.com/tools/v2/account.html#/privacy-policy',
  br: 'https://online.hitpaw.com.br/tools/v2/account.html#/privacy-policy',
  de: 'https://online.hitpaw.de/tools/v2/account.html#/privacy-policy',
  en: 'https://online.hitpaw.com/tools/v2/account.html#/privacy-policy',
  es: 'https://online.hitpaw.es/tools/v2/account.html#/privacy-policy',
  fr: 'https://online.hitpaw.fr/tools/v2/account.html#/privacy-policy',
  id: 'https://online.hitpaw.id/tools/v2/account.html#/privacy-policy',
  inn: 'https://online.hitpaw.in/tools/v2/account.html#/privacy-policy',
  it: 'https://online.hitpaw.it/tools/v2/account.html#/privacy-policy',
  jp: 'https://online.hitpaw.jp/tools/v2/account.html#/privacy-policy',
  kr: 'https://online.hitpaw.kr/tools/v2/account.html#/privacy-policy',
  nl: 'https://online.hitpaw.nl/tools/v2/account.html#/privacy-policy',
  ru: 'https://online.hitpaw.ru/tools/v2/account.html#/privacy-policy',
  tr: 'https://tr.hitpaw.com/tools/v2/account.html#/privacy-policy',
  tw: 'https://online.hitpaw.tw/tools/v2/account.html#/privacy-policy',
};

export {
  HitPaw_Home_LinkData,
  HitPaw_OnlineTools_LinkData,
  HitPawToolkit_Buy_LinkData,
  HitPawToolkit_EXE_LinkData,
  HitPawWatermarkRemover_EXE_LinkData,
  HitPawWatermarkRemover_Buy_LinkData,
  HitPaw_WatermarkRemover_Product_LinkData,
  HitPawVideoEditor_EXE_LinkData,
  HitPawVideoEditor_Buy_LinkData,
  HitPawVideoEdito_Product_LinkData,
  HitPaw_Video_Converter,
  HitPaw_Screen_Recorder_LinkData,
  Hitpaw_Cutter_LinkData,
  HitPaw_Service_LinkData,
  HitPaw_Privacy_LinkData,
  HitPawConvertLinkData,
};
